<template>
  <iRow
    align="center"
    style="padding-top: 100px"
    :style-overrides="{
      paddingTop: 'small',
      paddingBottom: 'small',
      paddingLeft: 'small',
      paddingRight: 'small',
    }"
  >
    <iColumn :max-width="400" align="center">
      <iRow style="width:33% !important">
        <iImageContainer :src="publicationData.publication_logo" />
      </iRow>
      <iColumn gap="none" align="center">
        <iDisplayText variant="small" align="center">
          Join {{ publicationData.name }}
        </iDisplayText>
        <iText text-align="center">
          {{ publicationData.tagline ?? "The community for pro marketers" }}
        </iText>
      </iColumn>
      <iSpace :height="40" width="fill" />
      <iColumn gap="none" align="center" vertical-align="middle">
        <template v-if="currentUserFlowStep === EMAIL_FORM">
          <JoinPublicationEmail />
        </template>
        <template v-if="currentUserFlowStep === PASSWORD_FORM">
          <JoinPublicationPassword />
        </template>
        <template v-if="currentUserFlowStep === SIGN_UP_FORM">
          <JoinPublicationSignUp />
        </template>
        <template v-if="currentUserFlowStep === COMPLETE_ACCOUNT_FORM">
          <JoinPublicationCompleteAccount />
        </template>
        <template v-if="currentUserFlowStep === SELECT_USER_FORM">
          <JoinPublicationExistingAccount />
        </template>
      </iColumn>
    </iColumn>
  </iRow>
</template>

<script>
import JoinPublicationEmail from "@/components/join-publication/JoinPublicationEmail.vue";
import { mapState } from "pinia";
import JoinPublicationPassword from "@/components/join-publication/JoinPublicationPassword.vue";
import { useGeneralStore } from "%/stores/general-store";
import JoinPublicationExistingAccount from "@/components/join-publication/JoinPublicationExistingUser.vue";
import { useUserStore } from "@/stores/user-store";
import {
  COMPLETE_ACCOUNT_FORM,
  EMAIL_FORM,
  PASSWORD_FORM,
  SELECT_USER_FORM,
  SIGN_UP_FORM,
} from "@/constants/login-flow-constants";
import JoinPublicationCompleteAccount from "@/components/join-publication/JoinPublicationCompleteAccount.vue";
import JoinPublicationSignUp from "@/components/join-publication/JoinPublicationSignUp.vue";

export default {
  name: "JoinPublication",
  components: {
    JoinPublicationSignUp,
    JoinPublicationCompleteAccount,
    JoinPublicationExistingAccount,
    JoinPublicationPassword,
    JoinPublicationEmail,
  },
  props: {
    publicationData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    EMAIL_FORM() {
      return EMAIL_FORM;
    },
    PASSWORD_FORM() {
      return PASSWORD_FORM;
    },
    SIGN_UP_FORM() {
      return SIGN_UP_FORM;
    },
    SELECT_USER_FORM() {
      return SELECT_USER_FORM;
    },
    COMPLETE_ACCOUNT_FORM() {
      return COMPLETE_ACCOUNT_FORM;
    },
    ...mapState(useGeneralStore, ["userId"]),
    ...mapState(useUserStore, ["currentUserFlowStep", "lastLoggedInUsers"]),
  },
  created() {
    if (!useUserStore().loginWithInspirationRequestId) {
      useUserStore().userFlowSteps = [COMPLETE_ACCOUNT_FORM];
    } else if (this.userId > 0 || Object.keys(this.lastLoggedInUsers).length > 0) {
      useUserStore().userFlowSteps = [SELECT_USER_FORM];
    }
  },
};
</script>

<style scoped lang="scss">

</style>
